import { gql } from "@apollo/client";
import { InvoiceStatus } from "TypesAndInterfaces";

export const restartInvoicesMutation = gql`
  mutation resetInvoices($params: RestartInvoicesInput!) {
    resetInvoices(params: $params)
  }
`;

export const syncShopAccountsMutation = gql`
  mutation syncShopAccounts($params: PullAccountsInput!) {
    syncShopAccounts(params: $params)
  }
`;

export const retryInvoicesMutation = gql`
  mutation retryInvoices($params: RetryInvoicesInput!) {
    retryInvoices(params: $params)
  }
`;

export const markInvoiceAsPaidMutation = gql`
  mutation markInvoiceAsPaid($data: MarkInvoiceAsPaidInput!) {
    markInvoiceAsPaid(params: $data)
  }
`;

export const getFailedInvoicesQuery = gql`
  query getFailedInvoices {
    getFailedInvoices {
      invoiceId
      shopId
      balancePlatformName
      channelName
      balanceAccountID
      payout
      payoutStatus
      commission
      commissionStatus
      subscription
      subscriptionStatus
      canRetry
      date
      retryCount
    }
  }
`;

export const getFailedInvoicesMarketplaceQuery = gql`
 query getFailedInvoices($marketplaceId: Float!) {
    getFailedInvoices(marketplaceId: $marketplaceId) {
      invoiceId
      shopId
      balancePlatformName
      channelName
      balanceAccountID
      payout
      payoutStatus
      commission
      commissionStatus
      subscription
      subscriptionStatus
      canRetry
      date
      retryCount
    }
  }
`;

export interface IFailedInvoicesQuery {
  invoiceId: number;
  payout: number;
  payoutStatus: InvoiceStatus;
  commission: number;
  commissionStatus: InvoiceStatus;
  subscription: number;
  subscriptionStatus: InvoiceStatus;
  canRetry: boolean;
  shopId: number;
  date: Date;
  retryCount: number;
  balancePlatformName: string;
  channelName: string;
  balanceAccountID: string;
  [key: string]: any;
}

export interface MarkInvoiceAsPaidInput {
  invoiceId: number;
  payout: boolean;
  commission: boolean;
  subscription: boolean;
  marketplaceId: number;
}
